import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

import { Checkbox, CheckboxProps, Text } from '@knowz/knowz-ui';
import { Controller, useFormContext } from 'react-hook-form';

interface RHFCheckboxProps
  extends Omit<FormControlLabelProps, 'control' | 'label'> {
  name: string;
  CheckboxProps?: CheckboxProps;
  label?: string;
  description?: string;
}

export default function RHFCheckbox({
  name,
  CheckboxProps,
  label,
  description,
  ...other
}: RHFCheckboxProps) {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      sx={{
        alignItems: description ? 'flex-start' : 'center',
        '& .MuiCheckbox-root': {
          padding: 0,
        },
      }}
      label={
        <Stack spacing={1}>
          <Text
            color="text.secondary"
            variant="textSm"
            weight="medium"
          >
            {label}
          </Text>

          {description && (
            <Text
              color="text.tertiary"
              variant="textSm"
            >
              {description}
            </Text>
          )}
        </Stack>
      }
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Checkbox
              size="small"
              {...field}
              checked={field.value}
              {...CheckboxProps}
            />
          )}
        />
      }
      {...other}
    />
  );
}
